//----------------------------------------------------------------------
//	PRIMARY NAVIGATION
//	Custom Package
//----------------------------------------------------------------------
//

var NavPrimary = {
	selector: '[data-nav-primary]',
	navPrimaryUl: '.nav-primary',
	selectorMenu: '[data-nav-toggle]',
	navHasChildren: '[data-nav-has-children]',
	navListItem: '.nav-primary__list-item',
	dropdownToggle: '.nav-primary__dropdown-toggle',
	subList: '.nav-primary__sublist',
	showElClass: 'js-show-element',
	openSubMenuClass: 'js-open-submenu',
	hoverClass: 'js-hovered',
	hideClass: 'js-hide',
	backMenu: '[data-nav-back]',
	subNavSecondaryButton: '.nav-primary__sublist-item > .nav-primary__dropdown-toggle',
	subNavPrimaryButton: '.nav-primary__list-item > .nav-primary__dropdown-toggle',
	seconLevelUl: '.nav-primary__list-item > .nav-primary__sublist',
	thirdLevelUl: '.nav-primary__sublist-item > .nav-primary__sublist',
	firstSubLink: '.nav-primary__list-item > ul > li > a',
	secondarySubLink: '.nav-primary__list-item > ul > li > ul',
	windowSize: 0,
	navBreakPoint: 1100,

	init: function () {
		// return if the container not present
		if (!$(this.selector).length) return;
		this.getWindowSize();
		this.setAttributes();
		this.setNavEvents();
		this.bindChangeEvent();
		this.addCurrentClass();
		this.bindClickEvent();
	},


	setNavEvents: function () {
		if (NavPrimary.windowSize >= NavPrimary.navBreakPoint) {
			NavPrimary.bindMouseEvent();
			NavPrimary.bindKeyboardEvent();
		} else {
			NavPrimary.unbindMobileEvent();
			NavPrimary.bindMobileEvents();
			NavPrimary.setAriaMenuMobile();
		}
	},
	bindChangeEvent: function () {

		// reset the functions and recalculate the values
		$(window).on('orientationchange resize load', function () {

			if (NavPrimary.windowSize !== window.innerWidth) {

				// Update variables
				NavPrimary.getWindowSize();
				NavPrimary.removeAttributes();
				NavPrimary.setAttributes();

				if (NavPrimary.windowSize >= NavPrimary.navBreakPoint) {

					NavPrimary.resetMobileNav();
					NavPrimary.unbindMobileEvent();
					NavPrimary.bindMouseEvent();
					NavPrimary.bindKeyboardEvent();
				} else {

					NavPrimary.resetMobileNav();
					NavPrimary.unbindMouseEvent();
					NavPrimary.unbindMobileEvent();
					NavPrimary.bindMobileEvents();
					NavPrimary.setAriaMenuMobile();
				}
			}

		});

	},

	getWindowSize: function () {
		// get window width and update the global value
		NavPrimary.windowSize = window.innerWidth;

		if (NavPrimary.windowSize >= NavPrimary.navBreakPoint) {
	
			NavPrimary.resetMobileNav();
			NavPrimary.unbindMobileEvent();
			NavPrimary.bindMouseEvent();
			NavPrimary.bindKeyboardEvent();
		} else {

			NavPrimary.resetMobileNav();
			NavPrimary.unbindMouseEvent();
			NavPrimary.unbindMobileEvent();
			NavPrimary.bindMobileEvents();
			NavPrimary.setAriaMenuMobile();
		}
	},

	bindMouseEvent: function () {

		// sub menu - When interacting with a li that has a sub menu
		$(NavPrimary.navHasChildren).on('mouseover mouseleave', function (e) {

			var $thisListItem = $(this);

			// If either tabbing into the li or hovering over the li
			if (e.type === 'mouseover') {

				// Show sub menu
				NavPrimary.addShowElClass($thisListItem);
			}

			// If mouse leaves li that has sub menu
			if (e.type === 'mouseleave') {

				// Hide sub menu
				NavPrimary.removeShowElClasss($thisListItem);
			}

		});

	},

	unbindMouseEvent: function () {
		$(NavPrimary.navHasChildren).off('mouseover mouseleave');
	},

	unbindMobileEvent: function () {
		$(NavPrimary.selectorMenu).off('click touchend');
		$(NavPrimary.backMenu).off('click touchend');
	},

	bindClickEvent: function () {
		$(NavPrimary.subNavPrimaryButton).on('click touchend', function (e) {

			var $this = $(this),
				$thisSubNav = $this.next(),
				$thisLi = $this.parent('li');

			if ($thisSubNav.hasClass(NavPrimary.showElClass)) {

				NavPrimary.closeDeskSubNav($this, $thisSubNav);
				if (e.type === 'touchend') {
					$('.nav-primary__list-item').removeClass('js-active');
				}

			} else {
				// add show class and set attributes
				$(NavPrimary.seconLevelUl).removeClass(NavPrimary.showElClass);
				$(NavPrimary.seconLevelUl).attr('aria-hidden', true);
				NavPrimary.openSubNav($this, $thisSubNav);

				if (e.type === 'touchend') {
					$('.nav-primary__list-item').removeClass('js-active');
					$('.nav-primary__sublist-item').removeClass('js-active');
					$thisLi.addClass('js-active');
				}
			}

			return false;
		});

		$(NavPrimary.subNavSecondaryButton).on('click touchend', function (e) {

			var $this = $(this),
				$thisSubNav = $this.next(),
				$thisLi = $this.parent('li');

			if ($thisSubNav.hasClass(NavPrimary.showElClass)) {
				// remove show class and reset attributes
				NavPrimary.closeDeskSubNav($this, $thisSubNav);
				if (e.type === 'touchend') {
					$('.nav-primary__sublist-item').removeClass('js-active');
				}

			} else {
				// add show class and set attributes
				NavPrimary.openSubNav($this, $thisSubNav);
				if (e.type === 'touchend') {
					$('.nav-primary__sublist-item').removeClass('js-active');
					$thisLi.addClass('js-active');
				}
			}

			return false;
		});

		// if user click outside the nav primary area 
		$('body').on('click touchmove keyup', function (e) {

			var $thisTarget = $(e.target),
				clickedOutside = $thisTarget.closest(NavPrimary.selector).length === 0;

			if (clickedOutside) {

				if (NavPrimary.windowSize >= NavPrimary.navBreakPoint) {

					// reset nav - close any submenu
					if ($(NavPrimary.subList).hasClass(NavPrimary.showElClass)) {
						NavPrimary.resetDeskNav();
					}

				} else {

					// close menu and reset mobile events
					if (clickedOutside && $('.global-header').hasClass('js-open')) {

						NavPrimary.resetMobileNav();
					}
				}

			}

		});

	},

	bindKeyboardEvent: function () {

		$('.nav-primary__link').on('keyup', function (e) {

			// remove and reset first level open dropdown menu
			NavPrimary.resetDeskNav();

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

		});

		$(NavPrimary.firstSubLink).on('keyup', function (e) {

			// remove and reset first level open dropdown menu
			NavPrimary.resetDeskSubNavDropdown();

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

		});

	},

	resetDeskNav: function () {
		$(NavPrimary.subList).removeClass(NavPrimary.showElClass);
		$('.nav-primary__list-item').removeClass('js-active');
		$('.nav-primary__sublist-item').removeClass('js-active');
		$(NavPrimary.dropdownToggle).attr('aria-expanded', false);
		$(NavPrimary.subList).attr('aria-hidden', true);
	},

	resetDeskSubNavDropdown: function () {
		$(NavPrimary.secondarySubLink).removeClass(NavPrimary.showElClass);
		$(subNavSecondaryButton).attr('aria-expanded', false);
		$(NavPrimary.secondarySubLink).attr('aria-hidden', true);
	},

	resetMobileNav: function () {
		$(NavPrimary.selectorMenu).removeClass('js-open');
		$('.global-header').removeClass('js-open');
		$('.header-nav').removeClass('js-open-submenu');

		// remove hide class to display LI back
		NavPrimary.removeHideClasss();
	},

	closeDeskSubNav: function ($this, $thisSubNav) {

		// remove show class and reset attributes
		$this.attr('aria-expanded', false);
		$thisSubNav.attr('aria-hidden', true);
		$thisSubNav.removeClass(NavPrimary.showElClass);
	},

	openSubNav: function ($this, $thisSubNav) {

		var $liSiblings = $this.parent().siblings('li'),
			$ulSiblings = $thisSubNav.siblings();

		$(NavPrimary.thirdLevelUl).attr('aria-hidden', true);
		$(NavPrimary.dropdownToggle).attr('aria-expanded', false);
		$this.attr('aria-expanded', true);
		$thisSubNav.attr('aria-hidden', false);


		if (NavPrimary.windowSize <= NavPrimary.navBreakPoint - 1) {

			// add show class to submenu
			setTimeout(function () {
				$(NavPrimary.thirdLevelUl).removeClass(NavPrimary.showElClass);
				$thisSubNav.addClass(NavPrimary.showElClass);
			}, 100);

			// once the animation is finished
			setTimeout(function () {
				// remove visibility from LI and UL siblings so that if the parent is longer then is not visible 
				// and prevent keyboard focus on elements that are visually hidden
				NavPrimary.addHideClass($liSiblings);
				NavPrimary.addHideClass($ulSiblings);

			}, 500);

		} else {
			$(NavPrimary.thirdLevelUl).removeClass(NavPrimary.showElClass);
			$thisSubNav.addClass(NavPrimary.showElClass);
		}

	},

	setAriaMenuMobile: function () {
		// set aria to main nav 
		$(NavPrimary.selectorMenu).attr('aria-expanded', 'false');
		$(NavPrimary.navPrimaryUl).attr('aria-hidden', 'true');
	},

	bindMobileEvents: function () {

		$(NavPrimary.selectorMenu).on('click touchend', function () {

			var $thisMenu = $(this);

			// set aria state
			var $thisMenuState = $thisMenu.attr('aria-expanded') === 'false' ? true : false;
			var primaryNavState = $(NavPrimary.navPrimaryUl).attr('aria-hidden') === 'true' ? false : true;

			$thisMenu.attr('aria-expanded', $thisMenuState);
			$(NavPrimary.navPrimaryUl).attr('aria-hidden', primaryNavState);
			$thisMenu.toggleClass('js-open');
			$('.global-header').toggleClass('js-open');

			// remove any opened submenu and reset attributes
			$(NavPrimary.subList).removeClass(NavPrimary.showElClass);
			$(NavPrimary.dropdownToggle).attr('aria-expanded', 'false');
			$(NavPrimary.subList).attr('aria-hidden', 'true');

			if (!$('.global-header').hasClass('js-open')) {

				NavPrimary.removeHideClasss();
			}

			return false;
		});

		$(NavPrimary.dropdownToggle).on('click touchend', function () {

			var $this = $(this),
				$thisSubNav = $this.next();

			// animate back to top
			$("html, body").animate({ scrollTop: 0 }, 300);

			// set the focus to the top of the navigation
			setTimeout(function () {
				$thisSubNav.attr('tabindex', '-1').trigger('focus');
			}, 100);

		});

		$(NavPrimary.backMenu).on('click touchend', function () {
			var $ulParent = $(this).parent('li').parent('ul'),
				$ulSiblings = $ulParent.siblings();
			var $LiSiblings = $ulParent.parent('li').siblings('li');

			// display LI and UL siblings
			$LiSiblings.removeClass(NavPrimary.hideClass);
			$ulSiblings.removeClass(NavPrimary.hideClass);

			// remove animation
			$ulParent.removeClass(NavPrimary.showElClass);

			// display none
			setTimeout(function () {
				// reset attributes
				$('.nav-primary__dropdown-toggle').attr('aria-expanded', false);
				$ulParent.attr('aria-hidden', true);

				// set the focus to the LI parent 
				$ulParent.parent('li').attr('tabindex', '-1').trigger('focus');

			}, 600);


			return false;
		});

	},

	setAttributes: function () {
		// set aria attributes on mobile layout
		$(NavPrimary.dropdownToggle).attr('aria-expanded', 'false');
		$(NavPrimary.subList).attr('aria-hidden', 'true');
	},

	removeAttributes: function () {
		// remove aria attributes on mobile layout
		$(NavPrimary.selectorMenu).removeAttr('aria-expanded');
		$(NavPrimary.navPrimaryUl).removeAttr('aria-hidden');
		$(NavPrimary.dropdownToggle).removeAttr('aria-expanded');
		$(NavPrimary.subList).removeAttr('aria-hidden');
	},

	addCurrentClass: function () {

		var $currentPageLink = $('.nav-primary a[href="' + document.location.pathname + '"]');

		// add current class and current page attribute
		$currentPageLink.addClass('is-current');
		$($currentPageLink).attr('aria-current', 'page');

	},

	addOpenSubMenuClass: function () {
		$(NavPrimary.navPrimaryUl).addClass(NavPrimary.openSubMenuClass);
	},

	removeOpenSubMenuClass: function () {
		$(NavPrimary.navPrimaryUl).removeClass(NavPrimary.openSubMenuClass);
	},

	addShowElClass: function ($thisListItem) {
		$thisListItem.children('ul').addClass(NavPrimary.showElClass);
	},

	removeShowElClasss: function ($thisListItem) {
		$thisListItem.children('ul').removeClass(NavPrimary.showElClass);
	},

	addHideClass: function ($liSiblings) {
		$liSiblings.addClass(NavPrimary.hideClass);
	},

	removeHideClasss: function ($thisListItem) {
		$('.nav-primary__list-item').removeClass(NavPrimary.hideClass);
		$('.nav-primary__sublist-item').removeClass(NavPrimary.hideClass);
		$('.nav-primary__dropdown-toggle').removeClass(NavPrimary.hideClass);
		$('.nav-primary__link').removeClass(NavPrimary.hideClass);
		$('.nav-primary__sublist-link').removeClass(NavPrimary.hideClass);
	}

};

$(document).ready(function () {
	NavPrimary.init();
});
